'use client'

import Link from 'next/link'
import Data from './data'
import Title from './title'
import LayoutBreadcrumb from '@/app/_components/layout/breadcrumb'
import { Content } from '@/app/_components/layout'

const breadcrumbItems = [
  { label: 'CANADA GOOSE Generationsトップ', href: '/' },
  { label: 'お支払い方法について', isCurrentPage: true },
]

const Payment = () => {
  return (
    <Content>
      <LayoutBreadcrumb items={breadcrumbItems} />
      <div className="container mx-auto px-5">
        <div className="w-full flex flex-col pb-32">
          <div>
            <h1 className="text-center text-2xl md:text-[26px] font-heading leading-10 pt-2 mb-4 md:mb-12 font-bold">
              お支払い方法について
            </h1>
          </div>
          <div className="flex flex-col lg:flex-row justify-around gap-x-14">
            <div className="hidden lg:block flex-shrink-0 pt-2">
              <div className={`sticky top-24`} id="title">
                <Title />
              </div>
            </div>
            <div className="lg:w-[1100px] w-full">
              <Data />
            </div>
          </div>
          <div className="flex justify-center items-center mt-14 md:mt-24">
            <Link
              href="/"
              className="w-full sm:max-w-[314px] h-auto p-0 text-xs sm:text-base border border-black bg-white text-black block  py-3.5 sm:py-3 text-center"
            >
              TOPに戻る
            </Link>
          </div>
        </div>
      </div>
    </Content>
  )
}

export default Payment
